/* eslint-disable max-len */

import _ from 'lodash';
import * as C from './userConstants';
import * as SC from '../sharedConstants';
import * as U from '../utils';
import * as SU from '../../utils';

// ------------ ACTIONS

const mutators = new Map();

const providers = {
  checkExpiration: U.makeAction(mutators, C.A_CHECK_EXPIRATION, _.identity),
  setUserPages: U.keyToValueAction(mutators, C.A_SET_USER_PAGES, 'userPages'),
  setGrants: U.keyToValueAction(mutators, C.A_SET_GRANTS, 'grants'),
  setProfile: U.keyToValueAction(mutators, C.A_SET_PROFILE, 'profile'),
  setAPIKey: U.keyToValueAction(mutators, C.A_SET_API_KEY, 'api_key'),
  setSession: U.keyToValueAction(mutators, C.A_SET_SESSION, 'session'),
  setAuthToken: U.keyToValueAction(mutators, C.A_SET_AUTH_TOKEN, 'auth_token'),
  clearProfile: U.makeSetValueAction(mutators, C.A_CLEAR_PROFILE, 'profile', null),
  setProfileStatus: U.keyToValueAction(mutators, C.A_SET_USER_STATUS, 'userStatus'),
  setTokenStatus: U.keyToValueAction(mutators, C.A_SET_TOKEN_STATUS, 'tokenStatus'),
  setGatekeeperStatus: U.keyToValueAction(mutators, C.A_SET_GATEKEEPER_STATUS, 'gatekeeperStatus'),
  userAuthorize: U.makeAction(mutators, C.A_LOG_IN_WITH_AUTH0, _.identity),
  userLogout: U.makeAction(mutators, C.A_LOG_OUT_WITH_AUTH0, _.identity),
  startGatekeeper: U.makeAction(mutators, C.A_INIT_GATEKEEPER, _.identity),
  startGatekeeperFromCallback: U.makeAction(mutators, C.A_INIT_GATEKEEPER_CALLBACK, _.identity),
  gatekeeperStarted: U.makeSetValueAction(mutators, C.A_START_GATEKEEPER, 'startedGatekeeper', true),
  gatekeeperCallbackStarted: U.makeSetValueAction(mutators, C.A_START_GATEKEEPER_CALLBACK, 'startedGatekeeperCallback', true),
  listeningToSession: U.makeSetValueAction(mutators, C.A_LISTENING_TO_SESSION, 'listeningToSession', true),
  setAccessToken: U.keyToValueAction(mutators, C.A_SET_ACCESS_TOKEN, 'accessToken'),
  setEphemeralKey: U.keyToValueAction(mutators, C.A_SET_EPHEMERAL_KEY, 'ephemeralKey'),
  setIDToken: U.keyToValueAction(mutators, C.A_SET_ID_TOKEN, 'idToken'),
  reloadEphemeralKey: U.makeAction(mutators, C.A_RELOAD_EPHEMERAL_KEY, _.identity),
};

// -------------- RESOLVER

let ephemeralKey = SU.getSession();
if (_.get(ephemeralKey, 'exp', 0) < Date.now()) {
  ephemeralKey = null;
}

const initialValue = {
  profile: null,
  api_key: null,
  auth_token: null,
  accessToken: null,
  grants: [],
  ephemeralKey,
  userStatus: SC.NOT_LOADED,
  tokenStatus: ephemeralKey ? SC.LOADED : SC.NOT_LOADED,
  gatekeeperStatus: SC.NOT_LOADED,
  startedGatekeeper: false,
  startedGatekeeperCallback: false,
  listeningToSession: false,
  session: null,
  userPages: [],
};

const resolver = (state = initialValue, { type, payload }) => {
  if (!mutators.has(type)) {
    return state;
  }

  return mutators.get(type)(state, payload);
};

export { providers, mutators };

export default resolver;
